import { render, staticRenderFns } from "./ClockFace.vue?vue&type=template&id=25346b85&"
import script from "./ClockFace.vue?vue&type=script&lang=js&"
export * from "./ClockFace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports